export default function Step4Remarks({ remarks, setRemarks }) {
  return (
    <div data-testid="step-4-remarks">
      <div className="mb-6">
        <div className="overline text-[#C5A880] mb-2">Step 04</div>
        <h1 className="text-3xl sm:text-4xl font-display font-bold leading-tight">
          Remarks & notes
        </h1>
        <p className="text-white/50 mt-2 text-sm">
          Anything the workshop or client should know.
        </p>
      </div>
      <div className="card-luxe">
        <label className="label-luxe">Remarks</label>
        <textarea
          className="input-luxe !h-48 !py-4 resize-none"
          placeholder="Enter any notes or instructions"
          value={remarks}
          onChange={(e) => setRemarks(e.target.value)}
          data-testid="remarks-textarea"
          style={{ lineHeight: 1.6 }}
        />
        <p className="text-xs text-white/30 mt-2">
          Tip: mention delivery date, site conditions, or special hardware.
        </p>
      </div>
    </div>
  );
}
